import { Suspense, lazy } from 'react';
import { createBrowserRouter, Navigate } from 'react-router-dom';

import ProtectedRoute from './components/ProtectedRoute';
import LoginPage from './components/login/login';
import LandingPage from './routes/landing-page/landing-page';
import { regionsLoader } from './routes/regions/regions';

const StatisticalInfo = lazy(() => import('./routes/statistical-info/statistical-info'));
const Categories = lazy(() => import('./routes/categories/categories'));
const Aspects = lazy(() => import('./routes/aspects/aspects'));
const Regions = lazy(() => import('./routes/regions/regions'));
const Home = lazy(() => import('./routes/home/home'));
const About = lazy(() => import('./routes/about/about'));
const Prices = lazy(() => import('./routes/prices/prices'));
const Faqs = lazy(() => import('./routes/faqs/faqs'));
const PrivacyPolicy = lazy(() => import('./routes/privacy/privacy'));
const Root = lazy(() => import('./routes/root/root'));

const withRouteFallback = (element) => (
  <Suspense fallback={<div className="route-loading" aria-live="polite">Loading...</div>}>
    {element}
  </Suspense>
);

const router = createBrowserRouter([
  {
    path: '/',
    element: withRouteFallback(<Root />),
    children: [
      {
        path: '/',
        element: <LandingPage />,
      },
      {
        path: '/home',
        element: withRouteFallback(<Home />),
      },
      {
        path: '/faqs',
        element: withRouteFallback(<Faqs />),
      },
      {
        path: '/privacy',
        element: withRouteFallback(<PrivacyPolicy />),
      },
      {
        path: '/about',
        element: withRouteFallback(<About />),
      },
      {
        path: '/intro',
        element: (
          <ProtectedRoute>
            {withRouteFallback(<StatisticalInfo />)}
          </ProtectedRoute>
        ),
      },
      {
        path: '/categories',
        element: (
          <ProtectedRoute>
            {withRouteFallback(<Categories />)}
          </ProtectedRoute>
        ),
      },
      {
        path: '/aspects',
        element: (
          <ProtectedRoute>
            {withRouteFallback(<Aspects />)}
          </ProtectedRoute>
        ),
      },
      {
        path: '/regions',
        element: (
          <ProtectedRoute>
            {withRouteFallback(<Regions />)}
          </ProtectedRoute>
        ),
        loader: regionsLoader,
      },
      {
        path: '/prices',
        element: (
          <ProtectedRoute>
            {withRouteFallback(<Prices />)}
          </ProtectedRoute>
        ),
        loader: regionsLoader,
      },
      {
        path: '/login',
        element: <LoginPage />,
      },
      {
        path: '*',
        element: <Navigate to="/" />,
      },
    ],
  },
]);

export default router;
